'use strict';

module.exports = {
  Timeline: require('./Timeline').default,
  // eslint-disable-line global-require
  TimelineItem: require('./TimelineItem').default // eslint-disable-line global-require
};